import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Загрузить фото ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "el-upload__text" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Перетащите сюда"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("или"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("em", null, "Нажмите Загрузить фото")
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "el-upload__tip" }, " Макс. 10 файлов, jpg/png файлы размером менее, чем 3Mb ", -1)
const _hoisted_6 = { class: "d-flex justify-content-end" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Сбросить ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Сохранить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_pre = _resolveComponent("base-pre")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_pre, {
      hide: "",
      title: "articleData data",
      data: _ctx.articleData
    }, null, 8, ["data"]),
    _createVNode(_component_el_form, {
      rules: _ctx.newsRules,
      ref: "formRef",
      model: _ctx.articleData,
      class: "pt-7 ql-quil ql-quil-plain"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              lg: 16,
              sm: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "Заголовок",
                  prop: "title",
                  class: "el-form-item_offest-top",
                  ref: "refsTitle"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _ctx.articleData.title,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.articleData.title) = $event)),
                      placeholder: "Введите заголовок статьи"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              lg: 16,
              sm: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "isOnMain",
                  label: "Отображать на главной",
                  class: "el-form-item_offest-top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.articleData.isOnMain,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.articleData.isOnMain) = $event)),
                      "active-color": "#13ce66",
                      "inactive-color": "#cccccc",
                      "active-text": "Да",
                      "inactive-text": "Нет"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              lg: 16,
              sm: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "Анонс",
                  prop: "previewText",
                  ref: "refsPreviewText"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      rows: 4,
                      "show-word-limit": "",
                      type: "textarea",
                      maxlength: "500",
                      placeholder: "Введите анонс",
                      modelValue: _ctx.articleData.previewText,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.articleData.previewText) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              lg: 16,
              sm: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "text",
                  label: "Текст",
                  ref: "refsText"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      rows: 8,
                      type: "textarea",
                      "show-word-limit": "",
                      maxlength: "100000",
                      modelValue: _ctx.articleData.text,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.articleData.text) = $event)),
                      placeholder: "Введите текст"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              lg: 16,
              sm: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "category",
                  label: "Категория",
                  class: "el-form-item_offest-top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      clearable: "",
                      class: "w-100",
                      placeholder: "Выберите",
                      modelValue: _ctx.articleData.category,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.articleData.category) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoriesArray, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              lg: 16,
              sm: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "rubricsPath",
                  ref: "refsRubricsPath",
                  label: "Привязка к товарным рубрикам"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_cascader, {
                      clearable: "",
                      filterable: "",
                      class: "w-100",
                      props: _ctx.rubricProps,
                      id: "rubricsPath",
                      options: _ctx.rubricsInitTree,
                      modelValue: _ctx.articleData.rubricsPath,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.articleData.rubricsPath) = $event)),
                      placeholder: "Выберите название рубрики"
                    }, null, 8, ["props", "options", "modelValue"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              lg: 16,
              sm: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "Источник",
                  prop: "sourceNewsName",
                  ref: "refsSourceNewsName",
                  class: "el-form-item_offest-top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_el_autocomplete, {
                        id: "sourceNewsName",
                        "aria-expanded": "true",
                        "trigger-on-focus": false,
                        class: "inline-input w-100",
                        modelValue: _ctx.articleData.sourceNewsName,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.articleData.sourceNewsName) = $event)),
                        placeholder: "Введите название источника",
                        "fetch-suggestions": _ctx.suggestNewsSources,
                        onSelect: _cache[7] || (_cache[7] = ($event: any) => (_ctx.articleData.sourceNewsObject = $event)),
                        onInput: _ctx.typeNewsSource
                      }, null, 8, ["modelValue", "fetch-suggestions", "onInput"])
                    ])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              lg: 16,
              sm: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "sourcePhotosName",
                  label: "Источник фотографий",
                  class: "el-form-item_offest-top",
                  ref: "refsSourceNewsName"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_autocomplete, {
                        id: "sourcePhotosName",
                        "aria-expanded": "true",
                        "trigger-on-focus": false,
                        class: "inline-input w-100",
                        modelValue: _ctx.articleData.sourcePhotosName,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.articleData.sourcePhotosName) = $event)),
                        placeholder: "Введите название источника",
                        "fetch-suggestions": _ctx.suggestPhotoSources,
                        onSelect: _cache[9] || (_cache[9] = ($event: any) => (_ctx.articleData.sourcePhotosObject = $event)),
                        onInput: _ctx.typePhotoSource
                      }, null, 8, ["modelValue", "fetch-suggestions", "onInput"])
                    ])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              lg: 16,
              sm: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "photos",
                  label: "Фотографии",
                  class: "el-form-item_offest-top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_upload, {
                        drag: "",
                        multiple: "",
                        ref: "refsPhotos",
                        accept: ['image/png', 'image/jpeg'],
                        "list-type": "picture",
                        class: "upload-demo",
                        "auto-upload": false,
                        "file-list": _ctx.articleData.photos,
                        "on-change": _ctx.handleChangeUpload,
                        "on-remove": _ctx.handleRemoveUpload
                      }, {
                        tip: _withCtx(() => [
                          _hoisted_5
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            size: "small",
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          }),
                          _hoisted_4
                        ]),
                        _: 1
                      }, 8, ["file-list", "on-change", "on-remove"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { class: "el-row" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              lg: 16,
              sm: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_button, {
                        type: "secondary",
                        loading: _ctx.isFormLoading,
                        disabled: _ctx.doesFormHasBeenChanged,
                        onClick: _ctx.resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled", "onClick"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        loading: _ctx.isFormLoading,
                        disabled: _ctx.doesFormHasBeenChanged,
                        onClick: _ctx.submitForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled", "onClick"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"])
  ]))
}